export default __webpack_public_path__ + "static/media/landing.0cda5009.png";